import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { onGetTokenThunk } from './AuthorizationProvider.actions'
import AuthorizationContext from './AuthorizationProvider.context'
import { Root } from './AuthorizationProvider.styles'

/**
 * The Authorization Provider container.
 */
const AuthorizationProvider = ({ children }) => {
  const dispatch = useDispatch()
  const {
    accessToken,
    authInfo: { loading: loadingAuthInfo, isValid },
    gettingToken,
    error
  } = useSelector(state => state.authorizationProvider)

  useEffectOnce(() => {
    if (accessToken === undefined) {
      dispatch(onGetTokenThunk())
    }
  })

  if (!error && !(accessToken && !gettingToken && !loadingAuthInfo)) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return <AuthorizationContext.Provider value={{ isValid }}>{children}</AuthorizationContext.Provider>
}

AuthorizationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthorizationProvider
